import { Button } from '@mui/material';
import Iconify from './iconify';

interface UploadButtonProps {
  onUpload: (event: React.ChangeEvent<HTMLInputElement>) => void;
  accept?: string;
  multiple?: boolean;
  label?: string;
  startIcon?: React.ReactNode;
  onClick?: (event: React.MouseEvent<HTMLInputElement>) => void;
}

export default function UploadButton({
  onUpload,
  accept = 'image/*',
  multiple = true,
  label = 'Upload Files',
  startIcon = <Iconify icon='eva:plus-fill' />,
  onClick,
}: UploadButtonProps) {
  return (
    <Button variant='contained' component='label' startIcon={startIcon}>
      {label}
      <input
        hidden
        accept={accept}
        multiple={multiple}
        type='file'
        onChange={onUpload}
        onClick={onClick}
      />
    </Button>
  );
}
